var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faCopy, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed, nextTick, ref } from "vue";
import { copy } from "@/utils/clipboard";
import SlugInput from "./SlugInput.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditableUrl',
    props: {
        prefix: null,
        slug: null
    },
    emits: ["change", "submit"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCopy, faEdit, faCheck);
        const editing = ref(false);
        const slugInput = ref();
        const url = computed(() => props.prefix + props.slug);
        function onEdit() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                editing.value = true;
                yield nextTick();
                ((_a = slugInput.value) === null || _a === void 0 ? void 0 : _a.$el).focus();
            });
        }
        function onChange(value) {
            emit("change", value);
        }
        function onSubmit() {
            editing.value = false;
            emit("submit", props.slug);
        }
        const copied = ref(false);
        const clipboardTitle = computed(() => (copied.value ? "Copied!" : "Copy URL"));
        function onCopy() {
            copy(url.value);
            copied.value = true;
        }
        function onCopyOut() {
            copied.value = false;
        }
        return { __sfc: true, props, emit, editing, slugInput, url, onEdit, onChange, onSubmit, copied, clipboardTitle, onCopy, onCopyOut, FontAwesomeIcon, BButton, SlugInput };
    }
});
